import { useContext, FunctionComponent, useCallback } from 'react';
import AccordionContext from 'react-bootstrap/AccordionContext';
import { useAccordionToggle } from 'react-bootstrap/AccordionToggle';
import { Card } from 'react-bootstrap';

interface Props {
    eventKey: string;
    callback?: (expanded: boolean) => void;
}

const CustomAccordionToggle: FunctionComponent<Props> = ({ children, eventKey, callback }) => {
    const currentEventKey = useContext(AccordionContext);

    // sets the value for next click as the decoratedOnClick (next click) is provided with this value.
    const isCurrentEventKey = currentEventKey === eventKey;

    const decoratedOnClick = useAccordionToggle(
        eventKey,
        () => callback && callback(!isCurrentEventKey)
    );

    return <Card.Header onClick={decoratedOnClick}>{children}</Card.Header>;
};

export default CustomAccordionToggle;
